import { Phone, ArrowRight, Zap, Lock, Sparkles, KeyRound, LifeBuoy } from "lucide-react";
import { PHONE_DISPLAY, PHONE_LINK } from "@/lib/constants";

const reasons = [
  { icon: Zap, label: "Rapidité d'intervention" },
  { icon: Lock, label: "Confidentialité absolue" },
  { icon: Sparkles, label: "Simplicité totale" },
  { icon: KeyRound, label: "Service clé en main" },
  { icon: LifeBuoy, label: "Accompagnement professionnel" },
];

export default function WhyChooseUs() {
  return (
    <section
      id="pour-qui"
      className="py-20 md:py-32 bg-slate-50"
      data-testid="why-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Image */}
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://customer-assets.emergentagent.com/job_archives-secure-paca/artifacts/x356h7kh_prestations-audit-conseils-en-archivage-1.jpg"
              alt="Manutentionnaire ArchivExpress organisant des cartons d'archives sur rayonnages"
              className="w-full h-[320px] md:h-[480px] object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between text-white">
              <div className="rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-bold text-slate-900">
                Service clé en main
              </div>
              <div className="rounded-full bg-blue-600 px-3 py-1.5 text-xs font-bold">
                On s'occupe de tout
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
            Pourquoi nous choisir
          </div>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-950" data-testid="why-title">
            Pourquoi les entreprises <span className="text-blue-600">nous choisissent.</span>
          </h2>

          <ul className="mt-10 divide-y divide-slate-200" data-testid="why-list">
            {reasons.map(({ icon: Icon, label }) => (
              <li
                key={label}
                className="flex items-center gap-4 py-5"
                data-testid={`why-item-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <Icon className="h-6 w-6 text-slate-900 shrink-0" strokeWidth={1.5} />
                <span className="text-base md:text-lg font-semibold text-slate-900 tracking-tight">{label}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a
              href={`tel:${PHONE_LINK}`}
              className="inline-flex items-center justify-center gap-2 bg-slate-950 text-white font-bold py-4 px-6 rounded-2xl hover:bg-blue-600 transition-all"
              data-testid="why-call-button"
            >
              <Phone className="h-5 w-5" strokeWidth={2} />
              Appeler {PHONE_DISPLAY}
            </a>
            <a
              href="#devis"
              className="inline-flex items-center justify-center gap-2 bg-white border border-slate-200 text-slate-950 font-bold py-4 px-6 rounded-2xl hover:border-slate-950 transition-all"
              data-testid="why-quote-button"
            >
              Demander un devis
              <ArrowRight className="h-5 w-5" strokeWidth={1.75} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
